/*
 * Author: harper
 * File Created: Friday, 24-07-05 03:48 pm
 * Last Modified: Wednesday, 25-06-18 04:25 pm, by Ben Zhao
 */

import { useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Icon } from '@ucard/ds/Icon';
import { useScreenSize } from '@ucard/ds/utils';
import { getEnv } from '@web/utils';
import TgBotIcon from '@/components/FixedContactor';
import LandingContainer from '@/components/LandingContainer';
import { getStaticLocaleProps } from '@/utils/i18n';
import Card from './_modules/Card';
import DownLoadApp from './_modules/Download';
import Hero from './_modules/Hero';
import Payments from './_modules/Payments';
import Products from './_modules/Products';
const env = getEnv();
export default function Page() {
  const isXsScreen = useScreenSize('xs');
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const handleServiceClick = () => {
    // todo
    window.open('https://t.me/TheDeHelpBot', '_blank');
  };

  // 监听路由变化
  const handleRouteChange = useCallback((url: string) => {
    // 向父页面发送消息
    if (window.parent !== window) {
      window.parent.postMessage({
        type: 'ROUTE_START_CHANGE',
        origin: router.pathname,
        dest: url
      }, env === 'local' ? '*' : process.env.NEXT_PUBLIC_CARD_HOST || '*'); // 在生产环境应指定确切的父页面域名，而不是 '*'
    }
  }, [router.pathname]);
  useEffect(() => {
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [handleRouteChange, router]);
  useEffect(() => {
    handleRouteChange(router.asPath);
  }, []);
  return <LandingContainer meta={{
    title: 'DeCard'
  }} sx={{
    background: `linear-gradient(#030303 0%, #242633 25%, #1e1e1e 100%)`
  }} data-sentry-element="LandingContainer" data-sentry-component="Page" data-sentry-source-file="index.page.tsx">
      <Hero data-sentry-element="Hero" data-sentry-source-file="index.page.tsx" />
      <Card data-sentry-element="Card" data-sentry-source-file="index.page.tsx" />
      <Products data-sentry-element="Products" data-sentry-source-file="index.page.tsx" />
      <Payments data-sentry-element="Payments" data-sentry-source-file="index.page.tsx" />
      <DownLoadApp data-sentry-element="DownLoadApp" data-sentry-source-file="index.page.tsx" />
      {!isXsScreen && <TgBotIcon bottom={30} expandText={t('tgbot')} icon={<Icon name="Contact" sx={{
      width: '28px',
      height: '28px'
    }} />} onClick={handleServiceClick} />}
    </LandingContainer>;
}
export const getStaticProps = getStaticLocaleProps(['home']);